export const MODULE_NAME = 'accessControl';

export const NO_ACCESS_URL = '/no-access';
